import { createContext, useContext, PropsWithChildren, useState, useMemo } from 'react';

interface IProvider {
  id: number;
  name: string;
  schema: string;
  subdomain: string;
  is_billable: boolean;
  is_external_id_field_mandatory: boolean;
  uses_new_referral_process: boolean;
  incentiveProgramEnabled: boolean;
  created_at: Date | string;
  updated_at: Date | string;
  deleted_at: Date | string | null;
}

interface SettingsContextProps {
  provider: IProvider | null;
  setProvider: (provider: IProvider) => void;
  settings: {
    [key: string]: boolean;
  };
}

const defaults: SettingsContextProps = {
  provider: null,
  setProvider: () => {},
  settings: {},
};

const SettingsContext = createContext<SettingsContextProps>(defaults);

function SettingsProvider(props: PropsWithChildren) {
  const [provider, setProvider] = useState<IProvider | null>(null);
  const settings = useMemo(() => {
    return {
      NEW_REFERRAL_PROCESS: provider ? provider.uses_new_referral_process : false,
    };
  }, [provider]);

  return (
    <SettingsContext.Provider
      value={{
        provider,
        setProvider,
        settings,
      }}
      {...props}
    >
      {props.children}
    </SettingsContext.Provider>
  );
}

const useSettings = () => {
  const context = useContext(SettingsContext);
  if (context === undefined) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }

  return context;
};

export { SettingsProvider, useSettings };
